(<template>
  <div ref="SeriesAssignmentSection"
       class="series"
       @focusin="openSeriesAssignmentSection">
    <series-assignment-section>
      <div v-if="showErrors"
           slot="errors"
           :class="{'is-with-error': showErrors}"
           class="series__errors">
        <span v-for="(error, index) in dateTimesOverlappingErrors"
              :key="index"
              v-html="`${error}`"></span>
      </div>
    </series-assignment-section>
    <series-checkbox-section v-if="enableSeriesCheckboxes" />
  </div>
</template>)

<script>
  import {mapGetters, mapMutations, mapState} from 'vuex';
  import SeriesCheckboxSection from '@/components/booking_components/parts/series_section/SeriesCheckboxSection';
  import SeriesAssignmentSection from '@/components/booking_components/parts/series_section/SeriesAssignmentSection';

  export default {
    components: {
      'series-assignment-section': SeriesAssignmentSection,
      'series-checkbox-section': SeriesCheckboxSection,
    },
    props: {
      params: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    computed: {
      ...mapState('PostingStore/SeriesAssignmentStore', {
        jobSeries: ({jobSeries}) => jobSeries,
        // errors
        dateTimesOverlappingErrors: ({errors}) => errors.dateTimesOverlapping.errors || []
      }),
      ...mapGetters('FeatureFlagsStore', ['enableSeriesCheckboxes']),
      ...mapGetters('PostingNotifierStore', ['showSeriesBooking']),
      showErrors() { return this.dateTimesOverlappingErrors.length; },
      seriesAssignmentBtnText() { return this.$gettext('Serial booking'); },
      showAssignmentHelper() { return this.params.showAssignmentHelper; }
    },
    methods: {
      ...mapMutations('PostAssignmentHelperStore', [
        'openHelper',
        'setPopoverReference',
      ]),
      openSeriesAssignmentSection() {
        if (this.showAssignmentHelper) {
          this.setPopoverReference(this.$refs.SeriesAssignmentSection);
          this.openHelper('serialBookingDate');
        }
      },
    },
    mounted() {
      if (this.jobSeries.length === 0) {
        this.$store.dispatch('PostingStore/SeriesAssignmentStore/addAssignment');
        this.$store.dispatch('PostingStore/SeriesAssignmentStore/addAssignment');
      }
    }
  };
</script>

<style scoped src="@assets/css/assignment_dates.css"></style>

<style scoped>
  .series {
    width: 100%;
    margin-bottom: 16px;
  }

  .series__errors {
    display: block;
    width: 100%;
    margin: 0 15px;
    padding-bottom: 10px;
    color: #f04;
    font-size: 12px;
  }
</style>
